import { render, staticRenderFns } from "./groupClass.vue?vue&type=template&id=78a35dde&scoped=true"
import script from "./groupClass.vue?vue&type=script&lang=js"
export * from "./groupClass.vue?vue&type=script&lang=js"
import style0 from "./groupClass.vue?vue&type=style&index=0&id=78a35dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a35dde",
  null
  
)

export default component.exports